import { gql } from '@apollo/client';

export default gql`
  mutation UpdateOfflineTask($input: UpdateOfflineTaskInput!) {
    updateOfflineTask(input: $input) {
      id
    }
  }
`;
